export enum PackingListState {
    Pending = 0,
    Dispatched = 1,
    Delivered = 2
}

export enum PackingListType {
    Supplier = 0,
    Customer = 1
}

export type PackingList = {
    id?: string;
    packingListId?: string;
    packingListDate?: Date;
    orderId?: string;
    batchId?: string;
    notes?: string;
    orderedProductId?: string;
    supplierId?: string;
    packingListType?: PackingListType;
    packingListState?: PackingListState;
    rollIds?: string[];
}